<app-ui-severity-pill [score]="score"></app-ui-severity-pill>